"use client";

import React, { useEffect, useRef } from "react";
import { Button } from "primereact/button";

import CochargeLogo from "../../components/CochargeLogo";
import LoginHeroImg from "../../assets/images/green-road.avif";

import { Toast } from "primereact/toast";
import { ProgressSpinner } from "primereact/progressspinner";

import { useUserContext } from "../../contexts/UserContext";

const Login = () => {
  const {
    isLoading,
    isAuthorized,
    loginWithRedirect,
    isAuthenticated,
    logout,
  } = useUserContext();

  const toast = useRef(null);

  useEffect(() => {
    if (!isLoading && !isAuthorized && isAuthenticated) {
      toast?.current?.clear(); // only show one
      toast?.current?.show({
        severity: "error",
        summary: "Access Denied",
        detail: "You do not have admin privileges.",
        life: 6000,
      });
    }
  }, [isLoading, isAuthenticated, isAuthorized]);

  if (isLoading || isAuthorized) {
    return (
      <div className="loading-container">
        <ProgressSpinner />
      </div>
    );
  }

  return (
    <div className="flex h-screen">
      <Toast ref={toast} />

      <div className="w-full lg:w-4 h-full text-center px-6 py-6 flex flex-column justify-content-start">
        <CochargeLogo green />

        <div className="flex flex-column align-items-center justify-content-center gap-2 flex-grow-1">
          <div className="mb-3">
            {isAuthenticated ? (
              <h2> Access Denied </h2>
            ) : (
              <h2>Login to backoffice</h2>
            )}
          </div>

          <Button
            label={isAuthenticated ? "Logout" : "Login"}
            className="w-20rem uppercase"
            onClick={isAuthenticated ? logout : loginWithRedirect}
            style={{ backgroundColor: "#215248" }}
          />
        </div>

        {/* for positioning */}
        <div className="hidden md:block opacity-0">
          <CochargeLogo green />
        </div>
      </div>
      <div
        className="w-8 hidden lg:flex flex-column justify-content-between align-items-start px-6 py-6 bg-cover bg-norepeat"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${LoginHeroImg})`,
        }}
      >
        <div className="mt-auto mb-auto">
          <span className="block text-white text-7xl font-semibold">
            {isAuthenticated ? (
              <>
                Your account does not have
                <br />
                access to backoffice
              </>
            ) : (
              <>
                Access to your
                <br />
                cocharge backoffice account
              </>
            )}
          </span>
        </div>
      </div>
    </div>
  );
};

export default Login;
